import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover-device:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover-device:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover-device:bg-destructive/80",
        outline: "text-foreground",
        success: 
          "border-transparent bg-[var(--color-cta-success)]/20 text-[var(--color-cta-success)] hover-device:bg-[var(--color-cta-success)]/30",
        warning:
          "border-transparent bg-[var(--color-cta-warning)]/20 text-[var(--color-neutral-950)] hover-device:bg-[var(--color-cta-warning)]/30",
        error:
          "border-transparent bg-[var(--color-cta-danger)]/20 text-[var(--color-cta-danger)] hover-device:bg-[var(--color-cta-danger)]/30",
        info:
          "border-transparent bg-[var(--color-hover-overlay)] text-[var(--color-brand-primary)] hover-device:bg-[var(--color-hover-overlay)]/80",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants }; 